import { useQuery } from "@tanstack/react-query";
import { useUser } from "../../../contexts/UserContext";

export const useTransactionAnalytics = () => {
  const { currentUser } = useUser();

  return useQuery({
    queryKey: ["transactionAnalytics", currentUser?.uid],
    queryFn: async () => {
      const insights = [
        {
          type: "trend" as const,
          title: "Increased Shopping Expenses",
          description: "Your shopping expenses are 25% higher than last month",
          impact: 250,
          action: "View shopping breakdown",
        },
        {
          type: "anomaly" as const,
          title: "Unusual Transaction",
          description: "Large transaction detected at Apple Store",
          impact: 999,
          action: "Review transaction",
        },
        {
          type: "opportunity" as const,
          title: "Potential Savings",
          description: "Switch to annual subscription to save 20%",
          impact: 120,
          action: "See details",
        },
      ];

      return { insights };
    },
    enabled: !!currentUser?.uid,
  });
};
